export const env: Record<string, string | null> = {
  npm_package_version: '0.0.0',
};
